import React, { useContext } from 'react';
import { AppContext } from '../Context';
import { Alert, Container } from 'react-bootstrap';
import NavbarGlobal from './NavbarGlobal';
import PracticasRegistroPanel from './Components/PracticasRegistroPanel';

const PracticasAlumno = () => {
  const { currentUser } = useContext(AppContext);

  return (
    <div>
      <NavbarGlobal title="Registro de Prácticas" showBackButton={true} />
      <Container className="py-4">
        {currentUser?.uid ? (
          <PracticasRegistroPanel alumnoId={currentUser.uid} />
        ) : (
          <Alert variant="warning" className="mb-0">
            No se pudo identificar al alumno para cargar sus practicas.
          </Alert>
        )}
      </Container>
    </div>
  );
};

export default PracticasAlumno;
